import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'semantic-ui-react'
import StaticInput from './StaticInput'
import GenericSelect from './GenericSelect'
import LocationSelect from './LocationSelect'
import LocationStickers from '../LocationStickers'

import './MultiSelect.css'

class MultiSelect extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      chosen: null
    }

    // Bind events
    this.onChangeChosen = this.onChangeChosen.bind(this)
    this.onClickAdd = this.onClickAdd.bind(this)
    this.onClickRemove = this.onClickRemove.bind(this)
  }

  onChangeChosen(chosen) {
    this.setState({
      chosen
    })
  }

  onClickAdd() {
    this.props.onChangeSelectedKeys([
      this.state.chosen,
      ...this.props.selectedKeys
    ])
    this.setState({
      chosen: null
    })
  }

  onClickRemove(removeKey) {
    return () => {
      this.props.onChangeSelectedKeys(_.filter(
        this.props.selectedKeys,
        (key) => (key !== removeKey)
      ))
    }
  }

  render() {
    const selectAttrs = {
      label: this.props.label,
      loading: this.props.loading,
      selected: this.state.chosen,
      onChange: this.onChangeChosen,
      error: this.props.error,
      canSearch: true,
      useAddBtn: {
        onClick: this.onClickAdd,
        disabledMessage: _.isArray(this.props.forbiddenKeys) && _.contains(this.props.forbiddenKeys, this.state.chosen)
          ? this.props.forbiddenMessage
          : null
      }
    }
    return (
      <React.Fragment>
        {
          this.props.isLocations
            ? <LocationSelect
                options={_.filter(
                  this.props.options,
                  (option) => !_.contains(this.props.selectedKeys, option.id)
                )}
                {...selectAttrs}
              />
            : <GenericSelect
                options={_.filter(
                  this.props.options,
                  (option) => !_.contains(this.props.selectedKeys, option.key)
                )}
                {...selectAttrs}
              />
        }
        {
          _.map(
            this.props.selectedKeys,
            (key) => {
              const option = _.find(
                this.props.options,
                this.props.isLocations
                  ? ((option) => (option.id === key))
                  : ((option) => (option.key === key))
              )
              if (_.isUndefined(option)) {
                return null
              }
              return (
                <StaticInput
                  label=''
                  smallPadding={true}
                  content={
                    <div
                      className='multiselect-wrapper'
                    >
                      <div
                        className={`content ${this.props.isLocations ? 'small-padding' : 'large-padding'}`}
                      >
                        {
                          this.props.isLocations
                            ? <LocationStickers
                                stickers={option.stickers}
                              />
                            : option.value
                        }
                      </div>
                      <Button
                        compact={true}
                        icon='trash'
                        color='red'
                        type='button'
                        onClick={this.onClickRemove(key)}
                      />
                    </div>
                  }
                />
              )
            }
          )
        }
      </React.Fragment>
    )
  }
}

MultiSelect.propTypes = {
  label: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        key: PropTypes.oneOfType([
          PropTypes.string.isRequired,
          PropTypes.number.isRequired
        ]).isRequired,
        value: PropTypes.node.isRequired,
        searchValue: PropTypes.string
      }).isRequired,
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        stickers: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string.isRequired,
            color: PropTypes.shape({
              foreground: PropTypes.string.isRequired,
              background: PropTypes.string.isRequired
            }).isRequired
          }).isRequired
        ).isRequired,
        details: PropTypes.arrayOf(
          PropTypes.shape({
            icon: PropTypes.oneOf([ 'info', 'success', 'warning', 'failure' ]).isRequired,
            text: PropTypes.string.isRequired
          })
        )
      }).isRequired
    ])
  ).isRequired,
  error: PropTypes.string,
  selectedKeys: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.number.isRequired
    ])
  ).isRequired,
  onChangeSelectedKeys: PropTypes.func.isRequired,
  forbiddenKeys: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.number.isRequired
    ])
  ),
  forbiddenMessage: PropTypes.string,
  isLocations: PropTypes.bool
}

export default MultiSelect


// WEBPACK FOOTER //
// ./src/components/elements/forms/MultiSelect.js